export enum BenefitCalculationDrawerParams {
  ClaimSetNumber = 'claimSetNumber',
  ClaimId = 'claimId',
  CoverageId = 'coverageId',
  BenefitCalculationStatus = 'benefitCalculationStatus',
}
